import React, { ChangeEvent } from 'react';

import { Container } from './styles';
import { file } from '@babel/types';
import { toast } from 'react-toastify';

interface Props {
  id: string;
  icon: string;
  text: string;
  accept: string;
  uploadedFiles: any;
  onChange?: (files: File[]) => void;
  setShowAlertLimitSize: (showAlertLimitSize: boolean) => void;
  multiple?: boolean;
  capture?: boolean | 'user' | 'environment';
  maxSize?: number;
}

export default function FileInput({
  id,
  icon,
  text,
  accept,
  onChange,
  multiple,
  capture,
  maxSize
}: Props): JSX.Element {
  const validateSize = (file: File) => {
    return !(maxSize && file.size > maxSize);
  };

  const handleFileEvent = (e: ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target.files;

    if (fileList && fileList.length > 0) {
      const files = Array.from(fileList).filter(file => {
        const hasValidSize = validateSize(file);
        if (!hasValidSize) {
          // TODO: change file size
          toast.error('O arquivo que você escolheu excede o limite de 5mb.');
        }
        return hasValidSize;
      });
      onChange?.(files);
    }
  };

  return (
    <Container htmlFor={id}>
      <input
        id={id}
        type="file"
        hidden
        multiple={multiple}
        onChange={handleFileEvent}
        accept={accept}
        capture={capture}
      />
      <img src={icon} alt="" />
      <span>{text}</span>
    </Container>
  );
}
